import Layout from "@/layout/index.vue";

export default [
  // 营销管理
  {
    path: "/yxgl",
    name: "yxgl",
    component: Layout,
    redirect: "/smsquery",
    meta: {
      title: "营销管理",
    },
    children: [
      {
        path: "/smsquery",
        name: "smsquery",
        component: () => import("@/views/page/yxgl/SMSquery.vue"),
        meta: {
          title: "短信统计",
        },
      },
      {
        path: "/smsmonitor",
        name: "smsmonitor",
        component: () => import("@/views/page/yxgl/SMSmonitor.vue"),
        meta: {
          title: "数据看板",
        },
      },
      {
        path: "/smsmanage",
        name: "smsmanage",
        component: () => import("@/views/page/yxgl/SMSmanage.vue"),
        meta: {
          title: "短信管理",
        },
      },
      {
        path: "/smsreconciliation",
        name: "smsreconciliation",
        component: () => import("@/views/page/yxgl/SMSreconciliation.vue"),
        meta: {
          title: "短信对账明细",
        },
      },
      {
        path: "/smsrevenue",
        name: "smsrevenue",
        component: () => import("@/views/page/yxgl/SMSrevenue.vue"),
        meta: {
          title: "短信收益数据表",
        },
      },
    ],
  },
  // 企微管理
  {
    path: "/wecom",
    name: "wecom",
    component: Layout,
    redirect: "/wecom/user-list",
    meta: {
      title: "企微管理",
    },
    children: [
      {
        path: "/wecom/user-list",
        name: "wecomUserList",
        component: () => import("@/views/wecom/pages/user-list/index.vue"),
        meta: {
          title: "账户池管理",
          newPage: true,
        },
      },
    ],
  },
  
  // 营销管理
  // {
  //   path: "/market",
  //   name: "market",
  //   component: Layout,
  //   redirect: '/market/user-event',
  //   meta: {
  //     title: "营销管理",
  //   },
  //   children: [
  //     {
  //       path: "/market/user-event",
  //       name: "marketUserEvent",
  //       component: () => import("@/views/market/pages/user-event/index.vue"),
  //       meta: {
  //         title: "用户事件",
  //         newPage: true,
  //       },
  //     },
  //     {
  //       path: "/market/ownership",
  //       name: "marketOwnership",
  //       component: () => import("@/views/market/pages/ownership/index.vue"),
  //       meta: {
  //         title: "营销归属",
  //         newPage: true,
  //       },
  //     },
  //     {
  //       path: "/market/msg",
  //       name: "marketMsg",
  //       component: () => import("@/views/market/pages/msg/index.vue"),
  //       meta: {
  //         title: "消息内容",
  //         newPage: true,
  //       },
  //     },
  //     {
  //       path: "/market/task",
  //       name: "marketTask",
  //       component: () => import("@/views/market/pages/task/index.vue"),
  //       meta: {
  //         title: "营销任务",
  //         newPage: true,
  //       },
  //     },
  //     {
  //       path: "/market/stats",
  //       name: "marketStats",
  //       component: () => import("@/views/market/pages/stats/index.vue"),
  //       meta: {
  //         title: "转化归因",
  //         newPage: true,
  //       },
  //     },
  //   ],
  // },
]